/***********************
  GLOBAL STATE
************************/
let firedSteps = JSON.parse(sessionStorage.getItem("firedSteps") || "[]");
let lastCartSubtotal = Number(sessionStorage.getItem("lastKnownSubtotal") || 0);

/***********************
  CONFETTI (CANVAS)
************************/
const confettiCanvas = document.getElementById("confetti-canvas");
const myConfetti = confetti.create(confettiCanvas, {
  resize: true,
  useWorker: true
});

function launchConfettiInDrawer() {
  const drawer = document.getElementById("cart-drawer");
  if (!drawer) return;

  const rect = drawer.getBoundingClientRect();
  const originX = (rect.left + rect.width / 2) / window.innerWidth;
  const originY = Math.max(0, rect.top / window.innerHeight);

  myConfetti({
    particleCount: 220,
    spread: 140,
    startVelocity: 65,
    gravity: 0.9,
    ticks: 320,
    scalar: 1.2,
    origin: { x: originX, y: originY }
  });

  setTimeout(() => {
    myConfetti({
      particleCount: 160,
      spread: 360,
      startVelocity: 45,
      gravity: 1,
      ticks: 280,
      scalar: 1,
      origin: { x: originX, y: originY }
    });
  }, 120);

  setTimeout(() => {
    myConfetti({
      particleCount: 140,
      spread: 100,
      startVelocity: 25,
      gravity: 1.4,
      ticks: 260,
      scalar: 0.9,
      origin: { x: originX, y: originY }
    });
  }, 260);
}

/***********************
  PROGRESS BAR INJECT
************************/
function injectProgressBar() {
  if (document.querySelector(".cart-progress")) return;

  const drawerBody =
    document.querySelector(".cart-drawer__body") ||
    document.querySelector(".drawer__content") ||
    document.querySelector(".drawer__inner") ||
    document.querySelector(".cart-drawer");

  if (!drawerBody) return;

  drawerBody.insertAdjacentHTML("afterbegin", `
    <div class="cart-progress" style="
      padding:14px;
      padding-bottom:25px;
      border:1px solid #eee;
      border-radius:12px;
      margin-bottom:12px;
      background:#fff;
      display:none;
    ">
      <p class="progress-text" style="text-align:center;font-weight:700;color:#2363CB"></p>

      <div style="position:relative">
        <div style="height:10px;background:#eee;border-radius:6px;overflow:hidden">
          <div class="progress-fill" style="
            height:100%;
            width:0%;
            background:#FF0000;
            transition:width .3s ease, background-color .3s ease;
          "></div>
        </div>

        <div class="step-icon" data-step="0" style="
          position:absolute;
          top:50%;
          left:50%;
          transform:translate(-50%,-50%);
          opacity:.4;
        ">₹250 OFF</div>

        <div class="step-icon" data-step="1" style="
          position:absolute;
          top:50%;
          left:95%;
          transform:translate(-50%,-50%);
          opacity:.4;
        ">₹400 OFF</div>
      </div>
    </div>
  `);
}

/***********************
  UPDATE PROGRESS BAR
************************/
function updateProgressBar(cartSubtotal) {
  injectProgressBar();

  const bar = document.querySelector(".cart-progress");
  if (!bar) return;

  if (!cartSubtotal || cartSubtotal <= 0) {
    bar.style.display = "none";
    return;
  }

  bar.style.display = "block";
  lastCartSubtotal = cartSubtotal;
  sessionStorage.setItem("lastKnownSubtotal", cartSubtotal);

  const fill = bar.querySelector(".progress-fill");
  const text = bar.querySelector(".progress-text");
  const steps = bar.querySelectorAll(".step-icon");

  const step1 = window.progressSettings?.step1 || 2500;
  const step2 = window.progressSettings?.step2 || 4000;

  const COLOR_START = "#FF0000";
  const COLOR_MID   = "#F4B740";
  const COLOR_DONE  = "#008000";

  function setStep(index, completed) {
    const step = steps[index];
    if (!step) return;

    const alreadyFired = firedSteps.includes(index);

    if (completed) {
      step.style.opacity = "1";
      step.style.color = COLOR_DONE;

      if (!alreadyFired) {
        firedSteps.push(index);
        sessionStorage.setItem("firedSteps", JSON.stringify(firedSteps));

        step.animate(
          [
            { transform: "translate(-50%,-50%) scale(1)" },
            { transform: "translate(-50%,-50%) scale(1.3)" },
            { transform: "translate(-50%,-50%) scale(1)" }
          ],
          { duration: 350, easing: "ease-out" }
        );

        launchConfettiInDrawer();
      }
    } else {
      step.style.opacity = "0.4";
      step.style.color = "#999";
      firedSteps = firedSteps.filter(i => i !== index);
      sessionStorage.setItem("firedSteps", JSON.stringify(firedSteps));
    }
  }

  let percent = 0;
  let message = "";

  if (cartSubtotal >= step2) {
    percent = 100;
    message = `🎉 You unlocked <strong>₹400 OFF</strong>!`;
    fill.style.setProperty("background-color", COLOR_DONE, "important");
    setStep(0, true);
    setStep(1, true);
  } 
  else if (cartSubtotal >= step1) {
    const remaining = Math.ceil(step2 - cartSubtotal);
    percent = 50 + ((cartSubtotal - step1) / (step2 - step1)) * 50;
    message = `Add <strong>₹${remaining}</strong> more to get <strong>₹400 OFF</strong>`;
    fill.style.setProperty("background-color", COLOR_MID, "important");
    setStep(0, true);
    setStep(1, false);
  } 
  else {
    const remaining = Math.ceil(step1 - cartSubtotal);
    percent = (cartSubtotal / step1) * 50;
    message = `Add <strong>₹${remaining}</strong> more to get <strong>₹250 OFF</strong>`;
    fill.style.setProperty("background-color", COLOR_START, "important");
    setStep(0, false);
    setStep(1, false);
  }

  fill.style.width = percent + "%";
  text.innerHTML = message;
}

/***********************
  SAFE CART FETCH (NO STUCK)
************************/
let cartController = null;

function fetchCartSafe() {
  if (cartController) cartController.abort();
  cartController = new AbortController();

  fetch("/cart.js", { signal: cartController.signal })
    .then(r => r.json())
    .then(cart => updateProgressBar(cart.items_subtotal_price / 100))
    .catch(err => {
      if (err.name !== "AbortError") console.error(err);
    });
}

/***********************
  OBSERVE CART DRAWER
************************/
function observeCartDrawer() {
  const drawer =
    document.querySelector("#cart-drawer") ||
    document.querySelector(".cart-drawer");

  if (!drawer) return;

  new MutationObserver(() => {
    fetchCartSafe();
  }).observe(drawer, { childList: true, subtree: true });
}

/***********************
  QUANTITY CHANGE LISTENER
************************/
document.body.addEventListener("change", (e) => {
  if (e.target.matches('input[name="quantity"]')) {
    setTimeout(fetchCartSafe, 150);
  }
});

/***********************
  INIT
************************/
document.addEventListener("DOMContentLoaded", () => {
  if (lastCartSubtotal > 0) updateProgressBar(lastCartSubtotal);
  fetchCartSafe();
  observeCartDrawer();
});
